$(document).ready(function () {
    $("#part-lookup-form").on("submit", function (e) {
      e.preventDefault();

      let serialNumber = $("#serial-number-input").val();
      $("#part-product-lookup-links").empty().append('<p class="product-results">Searching...</p>');

      $.ajax({
        url: "https://pim.howardmiller.com/shopify/part-lookup.php",
        type: "POST",
        data: {
          serial_number: serialNumber,
        },
        dataType: "json",
        crossDomain: true,
        success: function (data) {
          console.log(data);
          $("#part-product-lookup-links").empty();

          if (data.success) {
            const hasLikely = data.likely_products && data.likely_products.length > 0;
            const hasUnlikely = data.unlikely_products && data.unlikely_products.length > 0;

            if (hasLikely || hasUnlikely) {
              $("#part-product-lookup-links").append(
                `<p>Based on the serial number provided, here are the available parts available for sale.</p>`
              );

              let likelyProductHtml = $("<div>").addClass("product-results");
              let unlikelyProductHtml = $("<div>").addClass("product-results");
              let imagesToLoad = 0;
              let imagesLoaded = 0;

              // Count all images first
              [data.likely_products, data.unlikely_products].forEach(products => {
                (products || []).forEach(product => {
                  if (product.image) imagesToLoad++;
                });
              });

              // Add loading message if there are images to load
              if (imagesToLoad > 0) {
                $("#part-product-lookup-links").append('<p class="loading-message">Loading...</p>');
              }

              // Process likely products
              if (hasLikely) {
                $("#part-product-lookup-links").append("<h4>Likely Products</h4>");
                data.likely_products.forEach(product => {
                  const productItem = createProductItem(product, () => {
                    imagesLoaded++;
                    checkAllImagesLoaded(imagesLoaded, imagesToLoad);
                  });
                  likelyProductHtml.append(productItem);
                });
                $("#part-product-lookup-links").append(likelyProductHtml);
              }

              // Process unlikely products
              if (hasUnlikely) {
                $("#part-product-lookup-links").append("<h4>Other Possible Products</h4>");
                data.unlikely_products.forEach(product => {
                  const productItem = createProductItem(product, () => {
                    imagesLoaded++;
                    checkAllImagesLoaded(imagesLoaded, imagesToLoad);
                  });
                  unlikelyProductHtml.append(productItem);
                });
                $("#part-product-lookup-links").append(unlikelyProductHtml);
              }

              // If no images to load or all loaded immediately, show content
              if (imagesToLoad === 0) {
                likelyProductHtml.show();
                unlikelyProductHtml.show();
                $(".loading-message").remove();
              }

              // Add a failsafe timer to show content after 5 seconds regardless
              setTimeout(function () {
                $(".loading-message").remove();
                $(".product-results").fadeIn(300);
              }, 5000);
            } else {
              showError();
            }
          } else {
            showError();
          }
        },
        error: function (jqXHR, textStatus, errorThrown) {
          console.error("Full error details:", jqXHR);
          showError();
        },
      });

      function checkAllImagesLoaded(imagesLoaded, imagesToLoad) {
        if (imagesLoaded >= imagesToLoad) {
          $(".loading-message").remove();
          $(".product-results").fadeIn(300);
        }
      }

      function createProductItem(product, onImageLoad) {
        const productItem = $("<div>").addClass("product-item");
        const link = $("<a>").attr("href", product.url).attr("target", "_blank");

        if (product.image) {
          const img = $("<img>").attr("alt", product.title).addClass("product-item-img");

          img.on("load error", onImageLoad);
          img.attr("src", product.image);
          link.append(img);
        } else {
          // For products without images, add a placeholder
          link.append($("<div>").text("No image available"));
        }

        link.append($("<h5>").text(product.title));
        productItem.append(link);
        return productItem;
      }

      function showError() {
        $("#part-product-lookup-links")
          .empty()
          .html(
            '<div><span>We\'re sorry, we did not find any parts available for sale based on the serial number provided.<br/>We recommend you contact a <a href="https://howardmiller.com/pages/find-a-service-center">service center</a> for further assistance.</span></div>'
          );
      }
    });
  });